import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { VisitModel } from '../models/visit.model';
import { MyAccommodationsComponent } from '../pages/components/my-accommodations/my-accommodations.component';
import { NewAccommodationComponent } from '../pages/components/new-accommodation/new-accommodation.component';
import { AuthService } from './auth.service';
import { GetTranslationService } from './get-translation.service';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class AccommodationService {

  visits: VisitModel[] = [];

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private mdlctrl: ModalController,
    private translator: GetTranslationService,
    private authServ: AuthService
  ) { }

  getVisits(id: number): Promise<VisitModel[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/profile_visit/' + id + '?' + new Date().getTime()).subscribe(
        {
          next: (resp: VisitModel[]) => {
            this.visits = resp;
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        });
    });
  }

  postVisit(data: VisitModel): Promise<VisitModel[]> {
    return new Promise((resolve, reject) => {

      data.start_date = dayjs(data.start_date).set('hour', 6).set('minute', 0).set('second', 0).set('millisecond', 0).toISOString();
      data.end_date = dayjs(data.end_date).set('hour', 6).set('minute', 0).set('second', 0).set('millisecond', 0).toISOString();

      data.night = dayjs(data.end_date).diff(data.start_date, 'day');

      this.http.post(environment.apiURL + '/profile_visit', data).subscribe(
        {
          next: (resp: VisitModel[]) => {
            this.visits = resp;
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        });
    });
  }

  controlVisits() {
    return new Promise(async (resolve, reject) => {
      let exist = false;
      this.visits = await this.getVisits(this.authServ.profile.id);
      this.visits.forEach(async (visit) => {
        if (dayjs(new Date()).diff(visit.end_date) < 0 && dayjs(new Date()).diff(visit.start_date) > 0) {
          exist = true;
        }
      });

      if (exist) {
        resolve(true);
      } else {
        const MSG = await this.translator
          .getTranslate('You can only create a request during your stay. Please complete the form to add a new accommodation period.');

        this.toaster.toastMachine(MSG, 'danger', 3000);

        const DIDADD = await this.openModal();
        if (DIDADD) {
          resolve(true);
        } else {
          reject();
          return false;
        }
      }
    });
  }

  async openModal() {
    const MODAL = await this.mdlctrl.create({
      component: NewAccommodationComponent,
      componentProps: { fromService: true },
      swipeToClose: true,
      cssClass: 'cardmodal'
    });

    await MODAL.present();

    const didAdd = (await MODAL.onDidDismiss()).data;

    await this.getVisits(this.authServ.profile.id);

    if (didAdd) {
      return true;
    } else {
      return false;
    }
  }
}
